<script>
  import { page, pagenum } from './stores'
  import { doLogin, setUrl } from './logic'

  export let to
  // export let pg
  let obj = null
  export {obj as line}
  export let issue
  export let keep
  let clazz = "";
	export { clazz as class };

  async function process() {
    if (to === 'logout') {
      await doLogin('_logout', '')
      console.log('logout')
      $page = 'list'; 
    } else {
      $page = to; 
    }
    issue = obj; if (!keep) $pagenum = 1; 
    if (obj) { 
      if (!document.location.href.includes('?')) setUrl(obj.id,$page,$pagenum)
    } 
    else if (document.location.href.includes('?')) {
      window.history.replaceState('', '', '/')
    }
  }
</script>

<a class="{clazz}" href="/{obj ? '?id='+encodeURIComponent(obj.id) : ''}" title={to + (obj ? ' '+obj.id : '')} 
  on:click|preventDefault={() => {console.log('link',to,JSON.stringify(obj)); process();}}
>
  <slot/>
</a>